import branchFundingSourceallComponent from './branch_funding_source.all.component';

let branchFundingSourceallModule = angular.module('branchFundingSourceall', [
])

.component('branchFundingSourceall', branchFundingSourceallComponent)

.name;

export default branchFundingSourceallModule;


// WEBPACK FOOTER //
// ./client/app/components/branch_funding_source/all/index.js